import identity from "lodash/fp/identity";

class FileDownloadPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default FileDownloadPageTransform;



// WEBPACK FOOTER //
// ./src/pages/fileDownload/fileDownload.transforms.js